import { UPDATE_HEADER_INFO } from "./types";

export const updateHeaderInfo = data => async dispatch => {
    if (typeof data.iconOne === 'undefined') { data.iconOne = 'home'; }
    if (typeof data.iconTwo === 'undefined') { data.iconTwo = 'menu'; }
    if (typeof data.color === 'undefined') { data.color = '#00567a'; }
    switch (data.route) {
        case "home": {
            await dispatch({
                type: UPDATE_HEADER_INFO,
                payload: { headerText: "SASP", iconOne: "Home", iconTwo: "menu", backgroundcolor: data.color }
            });
            break;
        }

        default: {
            await dispatch({
                type: UPDATE_HEADER_INFO,
                payload: { headerText: data.name, iconOne: data.iconOne, iconTwo: data.iconTwo, backgroundcolor: data.color }
            });
            break;
        } 
    }
};